// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__D4LgF","noInteraction":"EventWrapper_noInteraction__1z-Ug","pointerPassthrough":"EventWrapper_pointerPassthrough__2ibdG"};